export const reasonsForDiscontinue = [
  { id: 300, text: 'Product has been recalled' },
  { id: 301, text: 'Product strength no longer marketed' },
  { id: 302, text: 'Product not marketed in the region (UK)' },
  { id: 303, text: 'Product removed from company portfolio' },
  { id: 304, text: 'Product replaced by an alternate' },
];

export const reasonsForDiscontinueOptions = reasonsForDiscontinue.map((r) => ({ id: r.id, value: r.text, label: r.text }));
